import classNames from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Fade from 'components/Fade';
import { Small, MediumUp } from 'components/MediaQuery';
import { BACKGROUND_TYPES, MODULE_TYPES } from 'constants/homepage';
import { medium, largeUp } from 'constants/mediaQueries';
import SecondaryPromoHero from 'models/SecondaryPromoHero';
import Theme from 'styles/theme';

import BackgroundImage from './BackgroundImage';
import BackgroundVideo from './BackgroundVideo';
import { IMAGE_HEIGHTS } from './constants';
import InlineVideoPlayer from './InlineVideoPlayer';
import Panel from './Panel';
import PlayButton from './PlayButton';

class HomepageV2SecondaryPromoHero extends React.Component {
  constructor() {
    super();
    this.state = { inlineVideoOpen: false };
  }

  get videoPlaying() {
    return !!(this.props.videoModalOpen || this.state.inlineVideoOpen);
  }

  openVideoModal = () => {
    const { openVideoModal, data } = this.props;
    openVideoModal(data.videoUrl);
  };

  openInlineVideo = () => {
    this.setState({ inlineVideoOpen: true });
  };

  closeInlineVideo = () => {
    this.setState({ inlineVideoOpen: false });
  };

  trackCTAClick = (url, label) => {
    const { data, homepagePosition } = this.props;
    const assetTitle = get(data, ['_data', 'heroAssetLandscape', 'title']);
    const internalName = get(data, ['_data', 'internalName']);

    this.props.trackModuleEvent({
      moduleType: MODULE_TYPES.SECONDARY_PROMO_HERO,
      moduleName: internalName,
      modulePosition: homepagePosition,
      imageName: assetTitle,
      linkCTAName: label,
      linkDestination: url,
    });
  };

  render() {
    const { data } = this.props;
    const { isInverted } = data;
    const { inlineVideoOpen } = this.state;

    return (
      <div
        className={classNames('HomepageV2SecondaryPromoHero', {
          'HomepageV2SecondaryPromoHero--inverted': isInverted,
        })}
      >
        <div className="HomepageV2SecondaryPromoHero__wrapper">
          <div className="HomepageV2SecondaryPromoHero__hero-asset">
            {data.backgroundType === BACKGROUND_TYPES.VIDEO && (
              <BackgroundVideo video={data.backgroundAsset} paused={this.videoPlaying} />
            )}
            {data.backgroundType === BACKGROUND_TYPES.IMAGE && (
              <BackgroundImage image={data.backgroundAsset} />
            )}
          </div>
          {data.videoUrl && (
            <>
              <Small>
                <PlayButton onClick={this.openVideoModal} />
              </Small>
              <MediumUp>
                <PlayButton onClick={this.openInlineVideo} />
              </MediumUp>
            </>
          )}
          <Fade show={inlineVideoOpen}>
            <InlineVideoPlayer onClose={this.closeInlineVideo} videoUrl={data.videoUrl} />
          </Fade>
        </div>
        <Panel
          heading={data.heading}
          subheading={data.subheading}
          ctaLinks={data.ctaLinks}
          onCTAClick={this.trackCTAClick}
          isInverted={isInverted}
        />

        <style jsx>{`
          .HomepageV2SecondaryPromoHero {
            position: relative;
            width: 100%;
            height: 100%;
            padding-bottom: ${Theme.get('spacing') * 12}px;
          }

          .HomepageV2SecondaryPromoHero--inverted {
            background-color: ${Theme.get('colors-black')};
          }

          @media ${medium} {
            .HomepageV2SecondaryPromoHero {
              padding-bottom: ${Theme.get('spacing') * 13}px;
            }
          }

          @media ${largeUp} {
            .HomepageV2SecondaryPromoHero {
              padding-bottom: ${Theme.get('spacing') * 20}px;
            }
          }

          .HomepageV2SecondaryPromoHero__wrapper {
            position: relative;
            width: 100%;
            height: ${IMAGE_HEIGHTS.SMALL}px;
            overflow: hidden;
          }

          @media ${medium} {
            .HomepageV2SecondaryPromoHero__wrapper {
              height: ${IMAGE_HEIGHTS.MEDIUM}px;
            }
          }

          @media ${largeUp} {
            .HomepageV2SecondaryPromoHero__wrapper {
              height: ${IMAGE_HEIGHTS.LARGE_UP}px;
            }
          }

          .HomepageV2SecondaryPromoHero__hero-asset {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: ${Theme.get('colors-black-80')};
          }
        `}</style>
      </div>
    );
  }
}

HomepageV2SecondaryPromoHero.propTypes = {
  data: PropTypes.instanceOf(SecondaryPromoHero).isRequired,
  videoModalOpen: PropTypes.bool.isRequired,
  openVideoModal: PropTypes.func,
  trackModuleEvent: PropTypes.func,
  homepagePosition: PropTypes.number,
};

HomepageV2SecondaryPromoHero.defaultProps = {
  openVideoModal: () => {},
  trackModuleEvent: () => {},
  homepagePosition: null,
};

export default HomepageV2SecondaryPromoHero;
